import { HttpClient } from '@angular/common/http';
import { Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { ApiService } from 'src/app/services/api.service';
import { DataService } from 'src/app/services/data.service';
import { FilterService } from 'src/app/services/filter.service';

@Component({
  selector: 'app-donut-chart-card',
  templateUrl: './donut-chart-card.component.html',
  styleUrls: ['./donut-chart-card.component.scss']
})
export class WidgetDonutChartCardComponent implements OnInit, OnDestroy {
  static key = 100103;

  @Input() item: any = {};
  @Input() pageKey: any;

  data: any[] = [];            // for old design
  newDesignData: any[] = [];   // for new design
  chartData: any[] = [];
  donutWidth = 8;
  heading = 'Processing Status';
  subHeading = '';
  headPercentage = '0';
  headRatio = '';
  loader = true;
  reqSubcription: Subscription[] = [];
  firstParam: any;
  secondParam: any;
  table_view = true;
  infoData: any;
  isOpen = false;
  selectedDesign = false;
  donutNewCenterText:any;

  constructor(
    private filterService: FilterService,
    private httpClient: HttpClient,
    private apiService: ApiService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe(() => {
        this.loader = true;
        this.loadApiData();
      })
    );
    this.loadChartConfig();
  }

  loadChartConfig() {
    this.data = [];
    this.newDesignData = [];

    const config: any[] = this.item.config?.['kpi_value_api_col'] || [];
    this.table_view = this.item.config?.['table_view']?.value === 'grid view';
    this.selectedDesign = this.item.config?.['selected_design']?.value === 'new';
    this.donutNewCenterText = this.item.config?.['donut_center_text'] || 'Accuracy';

    config?.map((c: any) => {
      //only selected column to be considered
      if (c['isSelected'] && c['isSelected'] == true) {
        this.data.push({
          id: c['api_column_list_key'],
          colName: c['api_resp_column_nm'],
          color: c['color'] || '#ddd',
          name: c['api_resp_column_display_nm'] || '',
          showInchart: c['showInChart']
        })
        this.newDesignData = [...this.data];
      }
    })
  }

  loadApiData() {
    const kpi = this.item.config?.['kpi_value_api'];
    if (kpi?.api_key && !this.filterService.isEmptyObject(this.filterService.baseQuery)) {
      const obj: any = { api_key: kpi.api_key };
      const query = { ...this.filterService.baseQuery, ...obj, report_typ: this.filterService.report_type };

      this.reqSubcription.push(
        this.httpClient.post(`${this.apiService.apiBaseUrl}/${this.apiService.executionUrl}`, query).subscribe(
          (res: any) => {
            if (res && res.length > 0) {

              let data = res[0]
              //assign the value to the selected parameter
              this.data.map((e) => {
                e['value'] = data?.[e?.['colName']] ? Number(data[e['colName']]) : 0
              })
            } else {
              this.data.map((e) => {
                e['value'] = 0
              })
            }

            this.loader = false;

            if (!this.selectedDesign) {
              this.getChartData(this.data);
            } else {
              this.newDesignData = [...this.data];
            }
          },
          () => {
            this.clearChartData();
            this.loader = false;
          }
        )
      );
    }
  }

  clearChartData() {
    this.headRatio = '';
    this.headPercentage = '';
    this.data.map(a => a['value'] = 0)
    this.newDesignData.map(a => a['value'] = 0)
    
  }

  getChartData(res: any[]) {
    this.firstParam = undefined;
    this.secondParam = undefined;

    if (res.length === 0) return;

    res = _.sortBy(res, ['value']);
    this.chartData = [];

    const maxItem = _.maxBy(res, 'value');
    this.firstParam = maxItem;
    this.subHeading = maxItem.name;

    res.forEach((d: any) => {
      if (d.showInchart) {
        this.chartData.push([
          { data: d.value, color: d.color },
          { data: maxItem.value - d.value, color: 'white' }
        ]);
        if (maxItem.name !== d.name) {
          this.subHeading = `${d.name} vs ${this.firstParam.name}`;
          this.secondParam = d;
        }
      }
    });

    if (this.firstParam && this.secondParam) {
      const percentagevalue = (this.secondParam.value / (this.firstParam.value || 1)) * 100;

      if (percentagevalue === 0 || percentagevalue === 100) {
        this.headPercentage = `${Math.floor(percentagevalue)}%`;
      } else if (percentagevalue % 1 === 0) {
        this.headPercentage = `${Math.floor(percentagevalue)}%`;
      } else {
        this.headPercentage = `${Math.floor(percentagevalue * 100) / 100}%`;
      }

      this.headRatio = `(${this.secondParam.value}/${this.firstParam.value})`;
    } else {
      this.headPercentage = '';
      this.headRatio = '';
    }
  }

  getInfoDetail() {
    const data = {
      api_key: this.item.config?.kpi_value_api?.api_key || '',
      widget_key: this.item.config?.widgetKey,
      page_key: this.pageKey,
      report_typ: 'D',
      brand_key: this.filterService.baseQuery?.brand_key
    };
    this.reqSubcription.push(
      this.dataService.getInfoDetail(data).subscribe((res: any) => {
        this.infoData = res && res[0] ? res[0] : { info_header: 'No Info Data Found' };
      })
    );
    return (this.isOpen = !this.isOpen);
  }

  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;
  closeMenu() {
    this.trigger.closeMenu();
  }

  ngOnDestroy() {
    this.reqSubcription.forEach(res => res.unsubscribe());
  }
}
